import { useEffect, EffectCallback } from 'react'

export const useEffectOnce = (fn: EffectCallback) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(fn, [])
}
